import { useEffect, useState } from "react";
import { SezzleWidgetProps } from "./types";
import Script from "next/script";
import SezzleScript from '@base/components/src/Scripts/SezzleScript';
import { sezzleService } from '../../services';

const SezzleWidget = ({ salePrice, showSezzle }: SezzleWidgetProps) => {
  const [sezzleLoaded, setSezzleLoaded] = useState<boolean>(false);

  useEffect(() => {
    sezzleService.refreshUi(salePrice);
  }, [salePrice, showSezzle]);

  return salePrice && showSezzle ? (
    <>
      <div id="sezzle-widget-container" data-testid={"sezzle-widget-container"} className='cursor-pointer text-center'></div>

      <Script id="sezzle-script"
        defer
        strategy="lazyOnload"
        src={'/marketplace-static/js/sezzle-widget.js'}
        onReady={() => setSezzleLoaded(true)}
      />

      {sezzleLoaded && (
        <SezzleScript salePrice={salePrice} />
      )}
    </>
  ) : null;
};

export default SezzleWidget;
